import { MouseEvent, lazy } from "react";
import { updateNewConversation } from "../collaboration/DbtDocsReducer";
import HighlightAnchor from "../collaboration/HighlightAnchor";
import ShowConversationsButton from "../collaboration/ShowConversationsButton";
import useDbtDocsCollaboration from "../collaboration/useDbtDocsCollaboration";
import useHighlight from "../collaboration/useHighlight";
import DbtDocsCollaborationComponents from "../collaboration/DbtDocsCollaborationComponents";
import AddCommentButton from "./AddCommentButton";
import { useDbtDocsCollaborationDispatch } from "../collaboration/DbtDocsCollaborationProvider";
import { Stack } from "@altimateai/lego";

const DbtDocsRenderer = lazy(() => import("./DbtDocsRenderer"));

const DbtDocsDetails = () => {
  const { loading, shareDetails } = useDbtDocsCollaboration();
  const dispatch = useDbtDocsCollaborationDispatch();
  const { getHighlightedSelectionData, pos, onSelectionEnd } = useHighlight();
  const onAddComment = (e: MouseEvent) => {
    e.stopPropagation();
    const data = getHighlightedSelectionData();
    if (data) {
      dispatch(updateNewConversation(data));
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!shareDetails?.catalog_presigned_url || !shareDetails?.manifest_presigned_url) {
    return <div>Unable to load required artifacts. Please try again.</div>;
  }
  return (
    <div>
      <Stack direction="row" justify="end" className="mb-2">
        <AddCommentButton />
        <ShowConversationsButton />
      </Stack>
      <DbtDocsCollaborationComponents />
      <DbtDocsRenderer shareDetails={shareDetails} onSelectionEnd={onSelectionEnd} />
      {pos ? <HighlightAnchor pos={pos} onAddComment={onAddComment} /> : null}
    </div>
  );
};

export default DbtDocsDetails;
